// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const mudbray: PokeData = {
  "id": 749,
  "name": "mudbray",
  "height": 10,
  "weight": 1100,
  "base_experience": 77,
  "types": [
    PokeType.GROUND
  ],
  "api_moves": [
    "stomp",
    "double-kick",
    "mega-kick",
    "counter",
    "strength",
    "earthquake",
    "bide",
    "mud-slap",
    "rock-smash",
    "superpower",
    "mud-sport",
    "iron-defense",
    "heavy-slam",
    "bulldoze",
    "rototiller",
    "high-horsepower"
  ],
  "moves": [
    "double-kick",
    "earthquake",
    "mud-slap",
    "rock-smash",
    "superpower",
    "rototiller",
    "bonemerang",
    "magnitude",
    "fissure",
    "earth-power",
    "mud-shot",
    "mud-bomb",
    "sandstorm"
  ],
  "evolution_chain": {
    "id": 386,
    "item": null,
    "species": [
      {
        "name": "mudbray",
        "order": 749,
        "types": [
          PokeType.GROUND
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "mudsdale",
        "order": 750,
        "types": [
          PokeType.GROUND
        ],
        "evolves_from_species_id": 749,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 30,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 66.25,
    "speed": 45,
    "ability_power": 100
  },
  "stat_changes": [],
  "catch_rate": 190,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
